import { render, staticRenderFns } from "./paginate-simple.vue?vue&type=template&id=16f46f32&scoped=true&"
import script from "./paginate-simple.vue?vue&type=script&lang=js&"
export * from "./paginate-simple.vue?vue&type=script&lang=js&"
import style0 from "./paginate-simple.vue?vue&type=style&index=0&id=16f46f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f46f32",
  null
  
)

export default component.exports